<head>
  <title>Page login Wegestu</title>
  <meta name="description" content="Page login Wegestu" />
</head>
<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="login-page">
  <div class="d-flex flex-column flex-root" id="kt_app_root">
    <!--begin::Page bg image-->
    <!--end::Page bg image-->
    <!--begin::Authentication - Signup Welcome Message -->
    <div class="d-flex flex-column flex-center flex-column-fluid">
      <!--begin::Content-->
      <div class="d-flex flex-column flex-center p-10">
        <!--begin::Wrapper-->
        <div class="card-warp w-md-650px py-5 content-login">
          <div
            class="content py-15 py-lg-20"
            [formGroup]="generateLoginForm"
           
          >
            <div class="mb-7 signup-wrap">
              <a routerLink="/auth/register" class="signup" id="signup"
                >S'inscrire</a
              >
            </div>

            <!--begin::Logo-->
            <div class="mb-7 text-center">
              <a href="" class="">
                <img
                  alt="Logo"
                  src="/assets/media/logos/wegestu.png"
                  class="h-150px logo-login"
                />
              </a>
            </div>
            <!--end::Logo-->

            <!--begin::Illustration-->
            <div class="fv-row mb-8 input-login">
              <!--begin::Email-->
              <label
                _ngcontent-ng-c1923953899=""
                for="flexCheckDefault"
                class="form-check-label label-design email"
              >
                E-mail
              </label>
              <input
                type="text" 
                formControlName="username"
                placeholder="Email"
                name="email"
                autocomplete="on"
                class="form-control bg-transparent"
              />
              <app-feild-error
                [control]="generateLoginForm.get('username')"
                [controlName]="'email'"
              ></app-feild-error>

              <!--end::Email-->
            </div>
            <!--end::Input group=-->
            <div class="fv-row mb-8 input-login">
              <label
                for="flexCheckDefault"
                class="form-check-label label-design password"
              >
                Mot de passe
              </label>
              <input
                [type]="showPassword"
                formControlName="password"
                placeholder="mot de passe"
                name="password"
                autocomplete="off"
                class="form-control bg-transparent"
              />
              <i
                *ngIf="showPassword == 'password'"
                (click)="showPassword = 'text'"
                class="fa-regular fa-eye-slash"
              ></i>
              <i
                *ngIf="showPassword == 'text'"
                (click)="showPassword = 'password'"
                class="fa-regular fa-eye"
              ></i>
              <app-feild-error
                [control]="generateLoginForm.get('password')"
              ></app-feild-error>
              <div
                *ngIf="
                  generateLoginForm.get('password')?.hasError('pattern') &&
                  generateLoginForm.get('password')?.touched
                "
                class="text-danger"
              >
                Votre mot de passe doit contenir au moins 8 caractères dont une
                lettre MAJ , une lettre min et un caractère spécial.
              </div>
            </div>
            <div class="mb-3">
              <span
                *ngIf="noUserAccount != '' || !loadSpinner"
                style="color: red"
                ><small>{{ noUserAccount }}</small></span
              >
              <span *ngIf="validEmaill != ''" style="color: red"
                ><small>{{ validEmaill }}</small></span
              >
            </div>

            <!--end::Input group=-->
            <!--begin::Wrapper-->
            <div
              class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8"
            >
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="1"
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Se souvenir de moi
                </label>
              </div>
              <!--begin::Link-->
              <div class="password-link">
                <a href="auth/reset-mail" class="link-primary">Mot de passe oublié ?</a>
              </div>
             
              <!--end::Link-->
            </div>
            <!--end::Illustration-->
            <!--begin::Link-->
            <div class="mb-8 submit-btn text-center">
              <button
                *ngIf="!loadSpinner"
                [disabled]="!this.generateLoginForm.valid"
                class="btn btn-sm btn-primary w-100"
                (click)="
                  show_button_login ? login() : resendCodeVerification()
                "
              >
                {{ show_button_login ? "SE CONNECTER" : "Renvoyer code" }}
              </button>
              <div
                *ngIf="loadSpinner"
                class="spinner-border text-primary"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>

              <!--begin::Link-->

              <!--end::Link-->
            </div>
            <!--end::Link-->
          </div>
        </div>
        <!--end::Wrapper-->
      </div>
      <!--end::Content-->
    </div>
    <!--end::Authentication - Signup Welcome Message-->
  </div>
</div>

<div class="d-flex justify-content-center">
  <app-footer-unauthenticated></app-footer-unauthenticated>
</div>